<template>
  <div>
    <div class="promocode-wrap" style="width:720px; margin-bottom:20px">
      <div class="wrap-title" style="margin-bottom:20px">トライアル登録URL発行</div>
      <div class="promocode-box">
        <div class="promocode-title">参照クライアント<span style="color:red">*</span></div>
        <el-select
          v-model="selectedClientId"
          filterable
          remote
          clearable
          :remote-method="searchClients"
          :loading="clientLoading"
          placeholder="クライアント名で検索"
          style="width:360px"
          size="small"
          @change="onClientChange"
        >
          <el-option
            v-for="client in clients"
            :key="client.client_id"
            :label="formatClientLabel(client)"
            :value="client.client_id"
          />
        </el-select>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">営業担当メンバー</div>
        <el-select
          v-model="selectedPersonId"
          filterable
          clearable
          :disabled="!selectedClientId"
          :loading="memberLoading"
          placeholder="メンバーを選択"
          style="width:360px"
          size="small"
        >
          <el-option
            v-for="member in members"
            :key="member.person_id"
            :label="formatMemberLabel(member)"
            :value="member.person_id"
          />
        </el-select>
      </div>
      <div class="promocode-checkbox-desc" style="margin-bottom:16px">
        既存の社内アカウントと、そのメンバーを選択してください。登録時の契約経路はクライアント名、営業担当は選択したメンバー名が入ります。
      </div>
      <div class="w-100 flex-row" style="justify-content:flex-end">
        <el-button type="primary" :disabled="!selectedClientId || issuing" @click="issueUrl()">
          URLを発行
          <div class="loader--mini" v-show="issuing"></div>
        </el-button>
      </div>
    </div>

    <div class="data-table report">
      <div class="report-done-switch influencer" style="margin-bottom:10px">
        <div class="report-influencer-breadcrumb">
          <span class="report-influencer-breadcrumb-num">{{ list.length }}</span>件
        </div>
        <div class="flex-space"></div>
        <el-button type="info" size="small" @click="loadList()">
          再読み込み
          <div class="loader--mini" v-show="listLoading"></div>
        </el-button>
      </div>
      <div class="data-table-admin-wrap">
        <table class="data-table-admin">
          <thead>
            <tr>
              <th class="data-table-admin-th">URL</th>
              <th class="data-table-admin-th">クライアント名</th>
              <th class="data-table-admin-th">営業担当</th>
              <th class="data-table-admin-th">有効</th>
              <th class="data-table-admin-th">発行日時</th>
              <th class="data-table-admin-th">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in list" :key="row.id" class="data-table-admin-tr">
              <td class="data-table-admin-td" style="max-width:360px; word-break:break-all">{{ row.url }}</td>
              <td class="data-table-admin-td">{{ row.client_name }}</td>
              <td class="data-table-admin-td">{{ row.person_name || "（未設定）" }}</td>
              <td class="data-table-admin-td">
                <el-switch
                  v-model="row.is_active"
                  :active-value="1"
                  :inactive-value="0"
                  :disabled="statusUpdatingId === row.id"
                  @change="changeStatus(row)"
                />
              </td>
              <td class="data-table-admin-td">{{ row.created_at }}</td>
              <td class="data-table-admin-td">
                <el-button type="primary" size="mini" @click="copyUrl(row.url)">コピー</el-button>
              </td>
            </tr>
            <tr v-if="!listLoading && list.length === 0">
              <td class="data-table-admin-td" colspan="6">発行済みのURLはありません</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const createAPI = root + "/api/admin/trial_register_url_create";
const listAPI = root + "/api/admin/trial_register_url_list";
const statusAPI = root + "/api/admin/trial_register_url_status";
const membersAPI = root + "/api/admin/trial_register_url_members";
const loadAPI = root + "/api/admin/admin_load";

export default {
  name: "trialRegisterUrl",
  data() {
    return {
      selectedClientId: null,
      selectedPersonId: null,
      clients: [],
      members: [],
      clientLoading: false,
      memberLoading: false,
      issuing: false,
      list: [],
      listLoading: false,
      statusUpdatingId: null,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.searchClients("");
    this.loadList();
  },
  methods: {
    formatClientLabel(client) {
      const person = client.person_name ? " / " + client.person_name : "";
      return client.client_name + person + " (ID:" + client.client_id + ")";
    },
    formatMemberLabel(member) {
      const name = member.person_name || "（名前なし）";
      return name + " (ID:" + member.person_id + ")";
    },
    parseClients(data) {
      const columns = (data.columns || []).map((column) => column.value);
      const idIdx = columns.indexOf("client_id");
      const nameIdx = columns.indexOf("client_name");
      const personIdx = columns.indexOf("person_name");
      if (idIdx < 0 || nameIdx < 0) {
        return [];
      }
      return (data.list || []).map((row) => ({
        client_id: Number(row[idIdx].value),
        client_name: row[nameIdx] ? row[nameIdx].value : "",
        person_name: personIdx >= 0 && row[personIdx] ? row[personIdx].value : "",
      }));
    },
    searchClients(query) {
      this.clientLoading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("type", "client");
      params.append("sort_key", "client_id");
      params.append("sort_order", true);
      params.append("currentPage", 1);
      params.append("limit", 250);
      if (query) {
        params.append(
          "filter",
          JSON.stringify({
            column: "client_name",
            type: "rlike",
            value: query,
          })
        );
      } else {
        params.append("filter", "");
      }
      this.axios
        .post(loadAPI, params)
        .then((response) => {
          this.clients = this.parseClients(response.data.data || {});
          this.clientLoading = false;
        })
        .catch(() => {
          this.clientLoading = false;
        });
    },
    onClientChange() {
      this.selectedPersonId = null;
      this.members = [];
      if (this.selectedClientId) {
        this.loadMembers(this.selectedClientId);
      } else {
        this.memberLoading = false;
      }
    },
    loadMembers(clientId) {
      this.memberLoading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("client_id", clientId);
      this.axios
        .post(membersAPI, params)
        .then((response) => {
          if (this.selectedClientId !== clientId) {
            return;
          }
          if (response.data.status === "OK") {
            this.members = (response.data.list || []).map((row) => ({
              person_id: Number(row.person_id),
              person_name: row.person_name || "",
            }));
          } else {
            this.members = [];
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message || "メンバー一覧の取得に失敗しました",
            });
          }
          this.memberLoading = false;
        })
        .catch(() => {
          if (this.selectedClientId !== clientId) {
            return;
          }
          this.members = [];
          this.memberLoading = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "メンバー一覧の取得に失敗しました",
          });
        });
    },
    issueUrl() {
      if (!this.selectedClientId) {
        return;
      }
      this.issuing = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("client_id", this.selectedClientId);
      if (this.selectedPersonId) {
        params.append("person_id", this.selectedPersonId);
      }
      this.axios
        .post(createAPI, params)
        .then((response) => {
          this.issuing = false;
          if (response.data.status === "OK") {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "URLを発行しました",
            });
            this.loadList();
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message || "URLの発行に失敗しました",
            });
          }
        })
        .catch(() => {
          this.issuing = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "URLの発行に失敗しました",
          });
        });
    },
    loadList() {
      this.listLoading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      this.axios
        .post(listAPI, params)
        .then((response) => {
          const rows = response.data.list || [];
          this.list = rows.map((row) => ({
            ...row,
            is_active: Number(row.is_active),
          }));
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "URL一覧の取得に失敗しました",
          });
        });
    },
    changeStatus(row) {
      this.statusUpdatingId = row.id;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("id", row.id);
      params.append("is_active", row.is_active);
      this.axios
        .post(statusAPI, params)
        .then((response) => {
          this.statusUpdatingId = null;
          if (response.data.status === "OK") {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: row.is_active === 1 ? "URLを有効にしました" : "URLを無効にしました",
            });
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message || "状態の更新に失敗しました",
            });
            this.loadList();
          }
        })
        .catch(() => {
          this.statusUpdatingId = null;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "状態の更新に失敗しました",
          });
          this.loadList();
        });
    },
    copyUrl(url) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "URLがコピーされました",
          });
        })
        .catch(() => {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "URLのコピーに失敗しました",
          });
        });
    },
  },
};
</script>
